import React from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import '../assets/styles/Footer.scss'

function Footer() {
  return (
    <footer>
      <div>
        <a href="https://github.com/MuthomiEric" target="_blank" rel="noreferrer"><GitHubIcon/></a>
        <a href="https://www.linkedin.com/in/erick-muthomi-86329097/" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
      </div>
      <p>Erick Muthomi</p>
    </footer>
  );
}

export default Footer;